var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bids.length)?_c('ul',{directives:[{name:"dragscroll",rawName:"v-dragscroll",value:(true),expression:"true"}],staticClass:"bid-list pl-0"},_vm._l((_vm.bids),function(bid){return _c('bid',{key:bid.id,attrs:{"bid":bid,"language":_vm.locale}})}),1):_c('div',[_vm._v("\n    "+_vm._s(_vm.__('auction.no_bids_yet'))+".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }